// extracted by mini-css-extract-plugin
module.exports = {"root":"Link__root___3pzuK","gray":"Link__gray___3z4aH","purple":"Link__purple___1_8oZ"};